// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-tags::after {
  clear: both;
  content: "";
  display: table;
}

.srprs-tag {
  width: auto;
  display: inline-block;
  background-color: #f4f4f4;
  font-size: 12px;
  line-height: 1.25em;
  margin-right: 0.625em;
  margin-bottom: 0.625em;
  padding-top: 1em;
  padding-right: 2em;
  padding-bottom: 1em;
  padding-left: 2em;
  text-transform: uppercase;
}
.srprs-tag > .srprs-icon {
  fill: #c1c1c1;
  font-size: inherit;
  margin-left: 0.8em;
  transition-duration: 0.15s;
  transition-timing-function: ease-in-out;
  transition-property: transform;
}
.srprs-tag > .srprs-icon:hover {
  cursor: pointer;
  transform: rotate(90deg);
}
.srprs-tag.is-disabled {
  pointer-events: none;
  color: #cecece;
}
.srprs-tag.is-disabled > .srprs-icon {
  fill: currentColor;
}
.srprs-tag.is-strike-through {
  color: #a7a7a7;
}
.srprs-tag.is-strike-through strong {
  position: relative;
}
.srprs-tag.is-strike-through strong::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  border-bottom-width: 0.125em;
  border-bottom-style: solid;
  border-bottom-color: #a7a7a7;
  margin-top: -0.0625em;
}
.srprs-tags.solid .srprs-tag {
  box-sizing: border-box;
  background-color: #fff;
}
.srprs-tags.solid .srprs-tag.is-disabled {
  background: transparent;
  color: #222;
  border: 3px solid #222;
}

@media screen and (min-width: 375px) {
  .srprs-tag {
    font-size: 14px;
  }
}
@media screen and (min-width: 640px) {
  .srprs-tag {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Tags/Tags.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_clearfix.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AItME;EACE,WAAA;EACA,WAAA;EACA,cAAA;AJwMJ;;AAtMA;EACE,WAAA;EACA,qBAAA;EAEE,yBAAA;EAMA,eAAA;EAGA,mBAAA;EAGA,qBAAA;EACA,sBAAA;EAGA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAGA,yBAAA;AA2LJ;AAxLE;EACE,aAAA;EAEE,kBAAA;EAGA,kBAAA;EAGA,0BAAA;EACA,uCAAA;EACA,8BAAA;AAqLN;AAlLI;EACE,eAAA;EACA,wBAAA;AAoLN;AAhLE;EACE,oBAAA;EACA,cAAA;AAkLJ;AAhLI;EACE,kBAAA;AAkLN;AA9KE;EACE,cAAA;AAgLJ;AA/KI;EACE,kBAAA;AAiLN;AAhLM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EAEE,4BAAA;EACA,0BAAA;EACA,4BAAA;EAEF,qBAAA;AAgLR;AA3KE;EACE,sBAAA;EACA,sBAAA;AA6KJ;AA5KI;EACE,uBAAA;EACA,WAAA;EACA,sBAAA;AA8KN;;ACpQI;ED2FF;IAEI,eAAA;EA4KJ;AACF;AC1QI;EDkGF;IAEI,eAAA;EA0KJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n@import '../_Assets/scss/core';\n\n.srprs-tags {\n  @include clearfix;\n}\n\n.srprs-tag {\n  width: auto;\n  display: inline-block;\n  background: {\n    color: lighten(color(grey-light), 5%);\n  }\n  // border: {\n  //   radius: 10em;\n  // }\n  font: {\n    size: 12px;\n  }\n  line: {\n    height: 1.25em;\n  }\n  margin: {\n    right: 0.625em;\n    bottom: 0.625em;\n  }\n  padding: {\n    top: 1em;\n    right: 2em;\n    bottom: 1em;\n    left: 2em;\n  }\n  text: {\n    transform: uppercase;\n  }\n\n  > .srprs-icon {\n    fill: darken(color(grey-light), 15%);\n    font: {\n      size: inherit;\n    }\n    margin: {\n      left: 0.8em;\n    }\n    transition: {\n      duration: 0.15s;\n      timing-function: ease-in-out;\n      property: transform;\n    }\n\n    &:hover {\n      cursor: pointer;\n      transform: rotate(90deg);\n    }\n  }\n  // States\n  &.is-disabled {\n    pointer-events: none;\n    color: darken(color(grey-light), 10%);\n\n    > .srprs-icon {\n      fill: currentColor;\n    }\n  }\n\n  &.is-strike-through {\n    color: darken(color(grey-light), 25%);\n    strong {\n      position: relative;\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 50%;\n        border-bottom: {\n          width: 0.125em;\n          style: solid;\n          color: darken(color(grey-light), 25%);\n        }\n        margin-top: calc(0.125em / 2 * -1);\n      }\n    }\n  }\n\n  .srprs-tags.solid & {\n    box-sizing: border-box;\n    background-color: color(white);\n    &.is-disabled {\n      background: transparent;\n      color: color(black);\n      border: 3px solid color(black);\n    }\n  }\n}\n@include breakpoint(mobile-large) {\n  .srprs-tag {\n    font: {\n      size: 14px;\n    }\n  }\n}\n@include breakpoint(mobile-landscape) {\n  .srprs-tag {\n    font: {\n      size: 16px;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin clearfix {\n  &::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
